module.exports = __webpack_public_path__ + "img/sardines.af87750d.png";